(function () {
  'use strict';

  angular.module('eclipseApp.socialMedia').controller('socialMediaCtrl', ['$scope', '$rootScope', '$modal', '$http', '$stateParams', '$state', 'commonService', 'uteEndpoint', 'uteModal', 'uteLocale', function ($scope, $rootScope, $modal, $http, $stateParams, $state, commonService, uteEndpoint, uteModal, uteLocale) {


    $scope.socialMediaInfo = {};
    var lang = uteLocale.language;
    var userAccounts = $rootScope.userInfo.accounts;
    var allAccountNumbers = [];
    $scope.userFirstName=$rootScope.userInfo.firstName;
    $scope.userLastName=$rootScope.userInfo.lastName;
    $scope.accountHolderName=$scope.userFirstName +" "+ $scope.userLastName;

    if (!$scope.userLastName){
     $scope.accountHolderName=$scope.userFirstName;
    }



    for (var i = 0; i < userAccounts.length; i++) {
      allAccountNumbers[i] = userAccounts[i].accountNumber;
    }

    var accountNumber = allAccountNumbers[0];
    var multipleAccountNumbers = allAccountNumbers.toString();

    $scope.errorOccurred = false;
    $scope.accountHolderStatus = 'Yes';
    if ($rootScope.userInfo.profileType.subscriber) {
      $scope.accountHolderStatus = 'No';
    }
    ;
    $scope.socialMediaFormRules = {
      firstName: {
        required: true,
        pattern: '(^[a-zA-ZÀ-Ÿ- ]+$)'
      },
      lastName: {
        required: true,
        pattern: '(^[a-zA-ZÀ-Ÿ- ]+$)'
      },
      fidoNumber: {
        required: true,
        pattern: '(^\\d{3}\\d{3}\\d{4}$)|(^\\d{3}\\s\\d{3}\\s\\d{4}$)|(^\\d{3}\\.\\d{3}\\.\\d{4}$)|(^\\d{3}-\\d{3}-\\d{4}$)'
      },
      emailAddress: {
        required: true,
        pattern: '(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/)'
      },
      socialMediaUsername: {
        required: true,
      }
    };

    //$scope.checkFidoNumber = function (socialMediaForm) {
    //  if (typeof $scope.socialMediaInfo.fidoNumber == 'undefined') {
    //    socialMediaForm.$setPristine();
    //  }
    //};

    $scope.submitSocialMediaForm = function () {
    //console.log($scope.socialMediaInfo);
    if ($scope.socialMediaForm.$valid) {
      $http({
        method: 'POST',
        url: uteEndpoint('v1/socialMedia/sendNotification'),
        data: {
          fName: $scope.socialMediaInfo.firstName,
          lName: $scope.socialMediaInfo.lastName,
          lang: lang,
          userName: $scope.socialMediaInfo.socialMediaUsername,
          phoneNumber: $scope.socialMediaInfo.fidoNumber,
          emailAddress: $scope.socialMediaInfo.emailAddress,
          accountHolderStatus: $scope.accountHolderStatus,
          accountNumber: accountNumber,
          multipleAccountNumbers: multipleAccountNumbers,
          accountHolderName:$scope.accountHolderName,
        }
      }).success(function (data) {
        //console.log(data);
        if (data.status === 'SUCCESS') {
          var socialMediaInfoSuccess = $modal.open({
            controller :'socialMediaCtrl',
            size: 'sm',
            templateUrl: 'modules/social-media/views/social-media-thankyou-popup.html'
          });
        } else {
          $scope.errorOccurred = true;
        }
      }).error(function (data) {
        $scope.errorOccurred = true;
      });
      };
    };

    $scope.clear = function (socialMediaForm) {
      $scope.socialMediaInfo={};
      $scope.socialMediaInfo.firstName=$scope.socialMediaInfo.lastName=$scope.socialMediaInfo.socialMediaUsername=$scope.socialMediaInfo.fidoNumber=$scope.socialMediaInfo.emailAddress='';
      socialMediaForm.$rollbackViewValue();
      socialMediaForm.$setPristine();
      socialMediaForm.$setUntouched();
      $scope.socialMediaFormRules.firstName.required = true;
      $scope.socialMediaFormRules.lastName.required = true;
      $scope.socialMediaFormRules.fidoNumber.required = true;
      $scope.socialMediaFormRules.emailAddress.required = true;
      $scope.socialMediaFormRules.socialMediaUsername.required = true;
      $scope.errorOccurred = false;
    }
    $scope.backToAccount = function () {
      $state.go('myAccount.overview');
    };

  }]);
})();
